import React, {FC, useState} from 'react';
import {useTranslation} from 'react-i18next';
import styles from './RateContainer.module.scss';
import TitleWrapper from './../TitleWrapper';
import AddIcon from './../../assets/images/icons/add_icon.svg';
import NoIcons from './../../assets/images/icons/no_icons.svg';
import PublishButton from './../PublishButton';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import {MediakitSectionItem, addSectionItem, deleteMediakitSectionItem, selectMediakitUser, sortMediakitSectionItems, updateSectionItem} from './../../features/stores/mediakitUser.slice';
import {setDataChange} from './../../features/stores/changeData.slice';
import {store} from './../../app/store';
import {useSelector} from 'react-redux';
import SocialMediaItem from './../SocialMediaItem/SocialMediaItem';
import AddRateModal from './../AddRateModal/AddRateModal';
import {reorder} from '../../features/util';

const RateContainer: FC = () => {
    const {t, i18n} = useTranslation();
    const [addModal, setAddModal] = useState(false);
    const mediakitUser = useSelector(selectMediakitUser);
    const mediakitUserSections = mediakitUser.mediakitSection;
    const mediakitSectionData = mediakitUserSections.find(
        (section: any) => section.type === 'rates',
    );
    const socialSectionItems = mediakitSectionData?.mediakitSectionLinks?.filter((e: any) => e.isActive != false) || [];

    const handleAddRate = (link: any, forceReplace?: boolean) => {
      const obj = forceReplace ? link : {
        id: Date.now(), // id generated via UTC date (unique), so that we can later delete this item (this id is not sent do backend)
        url: '',
        orderNumber:
        socialSectionItems?.length || 0,
        type: link.key,
        placeholder: t(link.placeholder),
        linksSectionId: mediakitSectionData?.id,
      };
      store.dispatch(setDataChange(true));
      store.dispatch(addSectionItem(obj as unknown as MediakitSectionItem));
    };

    const handleUrlChange = (url: string, id: any) => {
        store.dispatch(updateSectionItem({id, data: {url: url}}));
        store.dispatch(setDataChange(true));
    };
    
    const handleDelete = (id: string) => {
        store.dispatch(updateSectionItem({id, data: {isActive: false}}));
        store.dispatch(setDataChange(true));
    };

    const handleVisibilityChange = (visible: boolean, id: any) => {
      store.dispatch(updateSectionItem({id, data: {isVisible: visible}}));
      store.dispatch(setDataChange(true));
    };

    const onDragEnd = (result: any) => {
        if (!result.destination) {
          return;
        }
        const itemsTemp = reorder(
            socialSectionItems,
            result.source.index,
            result.destination.index,
        ) as MediakitSectionItem[];
    
        itemsTemp.forEach((element: MediakitSectionItem, index: number) => {
          store.dispatch(updateSectionItem({id: element.id, data: {...element, orderNumber: index}}));
        });
        store.dispatch(sortMediakitSectionItems());
        store.dispatch(setDataChange(true));
      };
    const getMaxOrder = () => {
      const order = Math.max(...socialSectionItems.map((o) => o.orderNumber), 0);
      return (Number(order) + 1);
    };
    return (
        <div>
            {addModal && <AddRateModal handleAddRate={handleAddRate} orderNumber={getMaxOrder()} handleClose={() => setAddModal(false)} />}
            <TitleWrapper title={t('rates')} subtitle={t('all_your_rates')} />
            <div className={styles.main}>
                <div className={styles.add_icon} onClick={() => setAddModal(true)}>
                    <div>
                        <img src={AddIcon} />
                        {t('add_rate')}
                    </div>
                </div>
          {socialSectionItems?.length ? <div className={styles.drag_container}><DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable-rates">
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {socialSectionItems?.map((item: MediakitSectionItem, index: number) => (
                <Draggable
                  key={item.id}
                  draggableId={item.id.toString()}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <SocialMediaItem
                        key={item.id}
                        style={{...(index === 0 && {marginTop: '0'})}}
                        index={index}
                        id={item.id}
                        url={item.url}
                        orderNumber={item.orderNumber}
                        platform={item.platform}
                        onUrlChange={handleUrlChange}
                        onDelete={handleDelete}
                        onVisibilityChange={handleVisibilityChange}
                        isVisible={item.isVisible}
                        parent={'rates'}
                        description={item.description}
                        currency={item?.currency}
                        price={item?.price}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext></div> : 
                <div className={styles.no_icon}>
                    <img src={NoIcons} />
                    <div className={styles.no_icon_title}>
                        <div className={styles.title}>{t('no_link_to_display')}</div>
                        <div className={styles.sub_title}>{t('click_the_button_above_to_add_one')}</div>
                    </div>
                </div>}
            </div>
            <div className={styles.divider}></div>
            <div className={styles.publish_conatiner}>
                <PublishButton />
            </div>
        </div>
    );
};

export default RateContainer;
